export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5411.0e06299b.jpg";